'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _glamor = require('glamor');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reduxForm = require('redux-form');

var _ManageManufacturerValidation = require('../../utils/ManageManufacturerValidation');

var _ManageManufacturerValidation2 = _interopRequireDefault(_ManageManufacturerValidation);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _jsonwebtoken = require('jsonwebtoken');

var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);

var _config = require('./../../config');

var _utils = require('./../../utils');

var _ManufacturerManagePopup = require('@quixeltools/quixel-ui-library/dist/components/common/website/ManufacturerManagePopup');

var _ManufacturerManagePopup2 = _interopRequireDefault(_ManufacturerManagePopup);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _ThanksPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/ThanksPopup');

var _ThanksPopup2 = _interopRequireDefault(_ThanksPopup);

var _EducationSubscriptionPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/EducationSubscriptionPopup');

var _EducationSubscriptionPopup2 = _interopRequireDefault(_EducationSubscriptionPopup);

var _reactRedux = require('react-redux');

var _zendesk = require('../../redux/modules/zendesk');

var _ReportAssetPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/ReportAssetPopup');

var _ReportAssetPopup2 = _interopRequireDefault(_ReportAssetPopup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = (0, _glamor.css)({
  border: 'none',
  marginTop: '3.75em',
  width: '100%'
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  border: '1px solid #333',
  margin: '200px auto',
  width: '' + (_css.sizes.innerMaxWidthTighter + 4)
}));

var ManufacturerManageContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'ManufacturerManage',
  fields: ['assetName', 'assetDescription', 'assetLink', 'manufacturerName', 'manufacturerDescription', 'getInTouch', 'photo', 'removeAsset', 'manufacturerLink'],
  validate: _ManageManufacturerValidation2.default
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    token: state.zendesk.token,
    user: state.user,
    uploaded: state.zendesk.uploaded,
    uploading: state.zendesk.uploading
  };
}, { createTicket: _zendesk.createTicket, uploadFile: _zendesk.uploadFile }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ManufacturerManageContainer, _Component);

  function ManufacturerManageContainer(props) {
    (0, _classCallCheck3.default)(this, ManufacturerManageContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ManufacturerManageContainer.__proto__ || (0, _getPrototypeOf2.default)(ManufacturerManageContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null,
      psrc: '',
      pvalue: '',
      pname: ''
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    _this.onChangeFile = _this.onChangeFile.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ManufacturerManageContainer, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.psrc !== this.state.psrc) {
        this.props.uploadFile(nextState.psrc, '');
      }
    }
  }, {
    key: 'onChangeFile',
    value: function onChangeFile(e) {
      e.preventDefault();
      var file = e.target.files[0];
      var reader = new FileReader();
      var self = this;

      var photoProps = this.props.fields.photo;


      photoProps.onChange(e);

      if (file) {

        self.setState({
          pname: file.name
        });

        reader.onload = function (r) {
          function toBuffer(ab) {
            var buffer = new Buffer(ab.byteLength);
            var view = new Uint8Array(ab);
            for (var i = 0; i < buffer.length; ++i) {
              buffer[i] = view[i];
            }
            return buffer;
          }
          self.setState({
            psrc: toBuffer(r.target.result)
          });
        };

        reader.readAsArrayBuffer(file);

        self.setState({ pvalue: reader });
      }
    }
  }, {
    key: 'onSubmitClick',
    value: function onSubmitClick(values) {
      var _this2 = this;

      this.setState({
        message: null,
        error: null
      });

      var assetName = values.assetName,
          assetDescription = values.assetDescription,
          assetLink = values.assetLink,
          manufacturerName = values.manufacturerName,
          manufacturerDescription = values.manufacturerDescription,
          getInTouch = values.getInTouch,
          photo = values.photo,
          removeAsset = values.removeAsset,
          manufacturerLink = values.manufacturerLink;


      var tag = 'Manufacturer Manage';
      var uploadArray = [];
      if (this.props.token && this.props.token.length > 0) {
        uploadArray.push(this.props.token);
      }

      this.props.createTicket({ email: this.props.user.email, subject: tag, name: tag, comment: '\n Asset Name: ' + (assetName || '') + '\n Asset Description: ' + (assetDescription || '') + '\n Asset ID: ' + (this.props.assetId || '') + '\n Asset Link: ' + (assetLink || '') + '\nCompany Name: ' + (manufacturerName || '') + '\nCompany Description: ' + (manufacturerDescription || '') + '\nCompany Link: ' + (manufacturerLink || '') + '\nGet in touch: ' + (getInTouch || '') + '\nRemove Asset:' + (removeAsset || ''),
        tag: tag, uploads: uploadArray }).then(function () {
        _this2.setState({
          message: 'Thank you! We have your feedback. We\'ll take a look shortly!'
        });
        _this2.props.onClose();
      }, function (reason) {
        _this2.setState({
          error: reason.status
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          assetName = _props$fields.assetName,
          assetDescription = _props$fields.assetDescription,
          assetLink = _props$fields.assetLink,
          manufacturerName = _props$fields.manufacturerName,
          manufacturerDescription = _props$fields.manufacturerDescription,
          getInTouch = _props$fields.getInTouch,
          photoProps = _props$fields.photo,
          removeAsset = _props$fields.removeAsset,
          manufacturerLink = _props$fields.manufacturerLink,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          assetTitle = _props.assetTitle,
          manufacturerTitle = _props.manufacturerTitle,
          description = _props.description,
          tag = _props.tag,
          childReference = _props.childReference;


      return _react2.default.createElement(_ManufacturerManagePopup2.default, {
        icon: '/quixel_logo.png',
        title: 'Manage Asset',
        assetTitle: assetTitle,
        manufacturerTitle: manufacturerTitle,

        assetName: assetName,
        assetDescription: assetDescription,
        assetLink: assetLink,

        manufacturerName: manufacturerName,
        manufacturerDescription: manufacturerDescription,
        photoProps: photoProps,
        getInTouch: getInTouch,
        removeAsset: removeAsset,
        manufacturerLink: manufacturerLink,

        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),

        uploaded: this.props.uploaded,
        uploading: this.props.uploading,
        onChangeFile: this.onChangeFile,
        fileName: this.state.pname,
        onChildRef: childReference

      });
    }
  }]);
  return ManufacturerManageContainer;
}(_react.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ManufacturerManageContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ManufacturerManageContainer/ManufacturerManageContainer.jsx
// module id = 2570
// module chunks = 0